// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 76) return "static/chunks/76-c2014ad15d804dd2.js";
	if (chunkId === 4094) return "static/chunks/4094-8118fb5b75e7d3f3.js";
	if (chunkId === 6502) return "static/chunks/6502-d64e97d1b66a9541.js";
	if (chunkId === 7600) return "static/chunks/7600-4796542712d721d7.js";
	if (chunkId === 8594) return "static/chunks/8594-6644718153561de5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"0fbc1475b2b96a07","2592":"506d9151dca492fb","3156":"c38b8e787d86ab0c","3514":"7f91bd77674f07cb","4686":"bfd59265abc97dd3","6534":"6bfbd467d772a951","9724":"2e274ca12ec93be3","9835":"892c2acae59590bc"}[chunkId] + ".js";
};